__turbopack_context__.v({
  "cardTitle": "index-module-scss-module__nM5pnW__cardTitle",
  "header": "index-module-scss-module__nM5pnW__header",
  "icons": "index-module-scss-module__nM5pnW__icons",
  "paymentFormWrapper": "index-module-scss-module__nM5pnW__paymentFormWrapper",
});
